import { API } from "./axiosInstance"

/**
 * Gets all the applications with joined tables from usermanagement-service
 * @returns the applications with joined objects
 */
export const getApplications = async () => {
    const applications = await API.get(`/applications`);
    return applications.data;
}

/**
 * Get an application with joined tables from usermanagement-service
 * @returns the application with joined objects
 */
export const getOne = async (id) => {
    const application = await API.get(`/applications/` + id);
    return application.data;
}

/**
 * Calls the post application endpoint
 * @param {*} application the application to create
 * @returns the response from usermanagement-service
 */
export const createApplication = async (application) => {
    const response = await API.post(`/applications`, application);
    return response.data;
}

export const updateApplication = async (application, staticId) => {
    const response = await API.put(`/applications/${staticId}`, application);
    return response.data;
}

/**
 * Accepts a requested change for an application
 * @param {*} staticId the id of the application in the static model
 * @returns the accepted application
 */
export const acceptChange = async(staticId) => {
    const response = await API.post(`/applications/${staticId}/accept`);
    return response.data;
}

/**
 * Rejects a requested change for an application
 * @param {*} staticId the id of the application in the static model
 * @returns the rejected application
 */
export const rejectChange = async(staticId) => {
    const response = await API.post(`/applications/${staticId}/reject`);
    return response.data;
}